import { Model } from "@nozbe/watermelondb";
import { date, field, text, writer } from "@nozbe/watermelondb/decorators";
import { SyncState } from "../constants";

export abstract class SyncMeta extends Model {
  @text("sync_state") syncState: SyncState;
  @field("num_sync_attempts") numSyncAttempts: number;
  @date("last_sync_attempt") lastSyncAttempt: Date | null;

  @writer async updateSyncState(state: SyncState) {
    await this.update((item) => {
      item.syncState = state;
    });
  }

  @writer async increaseSyncAttempts(startedAt: Date) {
    await this.update((item) => {
      item.numSyncAttempts = item.numSyncAttempts + 1;
      item.lastSyncAttempt = startedAt;
    });
  }
}
